
import { computed, defineComponent, toRefs } from "vue";
import ListItemTag from "./ListItemTag.vue";
export default defineComponent({
  name: "listItem",
  props: {
    code: String,
    userName: String,
    title: String,
    content: String,
    footer: String,
    checked: {
      type: Boolean
    },
    type: String,
    typeName: String,
    selectable: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:checked", "on-toggle"],
  setup(props, { emit }) {
    const { checked, selectable, type } = toRefs(props);
    const value = computed({
      get() {
        return checked.value;
      },
      set(value) {
        emit("update:checked", value);
      }
    });
    const classes = computed(() => {
      return {
        "ListItem--checked": value.value
      };
    });
    const onToggle = () => {
      if (!selectable.value) return;
      value.value = !value.value;
      emit("on-toggle", value.value);
    };
    const statusClass = () => {
      if (type.value) {
        const obj: any = {
          1: "blue-status",
          2: "grey-status",
          3: "orange-status"
        };
        return obj[type.value];
      }
      return "";
    };

    return {
      value,
      onToggle,
      classes,
      statusClass
    };
  }
});
